(function () {
	'use strict';

	angular.module('app.setup')
		.service('pqByCostService', pqByCostService);

	pqByCostService.$inject = ['$http', 'tableService'];

	function pqByCostService($http, tableService) {
		var urlPfx = '/api/2/factndx/{0}/';
		return {
			getChartData: getChartData
		};

		function getChartData(filterService, itemCount) {
			var sites = filterService.getFactoryList();
			var url = String.format(urlPfx, sites) + 'PqByCost?count=' + itemCount;
			var filterQueryParams = filterService.getQueryParam();
			for (var i = 0; i < filterQueryParams.length; i++) {
				url = appendQueryParam(url, filterQueryParams[i].key, filterQueryParams[i].value);
			}

			tableService.trackPageView('pq-analysis/pq-by-cost', sites);

			return $http.get(url)
				.then(getChartDataComplete)
				.catch(getChartDataFailed);

			function getChartDataComplete(response) {
				return response.data;
			}

			function getChartDataFailed(error) {
				return error;
			}
		}
	}
})();
